import NextGen_Player from "../Pages/NextGen_Player"

let Maintenance = false

// Load Models
const LoadModel = async (Passed) => {
    let result = {}
    if (Maintenance) {
        Passed.Type = 'Maintenance'
    }
    switch (Passed.Type) {
        // Player Form
        case 'Player':
            result = await NextGen_Player.LoadSchema(Passed)
            break;
        // Maintenance Mode
        case 'Maintenance':
            result = {
                Portal: '2023 Next Gen Player Registration',
                MainColor: "#0305a1",
                Logo: require(`../../assets/BQLogo.png`),
                Title: `<h2>2023 Next Gen Player Registration</h2>`,
                Description: ``,
                Suspended: Maintenance,
                steps: [
                    // Step 1
                    {
                        stepno: 1,
                        title: 'Registrations Suspended Due to Maintence',
                        valid: true,
                        information: '',
                        Model: {},
                        Schema: {
                            maintenance: {
                                type: 'img',
                                src: 'https://admin.ownurgoal.net.au/_lib/file/imgArticles/UnderMaintenance2.png',
                                height: "100%",
                                width: "100%",
                                //maxHeight: 1366,
                                //maxWidth: 768,
                                // contain: true,
                                col: 12,
                                class: "ma-2"
                            },
                        }
                    },
                ]
            }
            break;

        default:
            break;
    }
    // Load the Model with step elements
    result.steps.forEach(element => {
        element.Model = result.Model
    });
    return result
}

export default {
    init: async (Parameters) => {
        let result = await LoadModel(Parameters)
        return result;
    },
}